// extracted by mini-css-extract-plugin
export default {"blockWrapper":"block-wrapper_blockWrapper__5V8gQ"};